<template>
  <div id="captcha-container" class="captcha-container">
    <div
      class="slide-verify"
      :style="{ width: canvasImgWidth + 'px' }"
      id="slideVerify"
      onselectstart="return false;"
    >
      <div id="slider-verified" class="d-none"><img :src="require('@/assets/img/icon/icon-captcha-verified.svg')"></div>
      <div :class="{ 'slider-verify-loading': loadBlock }"></div>
      <canvas :width="canvasImgWidth" :height="h" ref="canvas"></canvas>
      <div v-if="show" @click="refresh" class="slide-verify-refresh-icon"></div>
      <canvas
        :width="canvasImgWidth"
        :height="h"
        ref="block"
        class="slide-verify-block"
      ></canvas>
      <!-- container -->
      <div
        class="slide-verify-slider"
        :class="{
          'container-active': containerActive,
          'container-success': containerSuccess,
          'container-fail': containerFail
        }"
      >
        <div class="slide-verify-slider-mask" :style="{ width: sliderMaskWidth }">
          <!-- slider -->
          <span id="text-slider" class="fs-12 d-none text-color-white">{{ sliderDoneText }}</span>
          <div
            @mousedown="sliderDown"
            @touchstart="touchStartEvent"
            @touchmove="handleMoveEvent($event, 'touch')"
            @touchend="handleMoveEndEvent($event, 'touch')"
            class="slide-verify-slider-mask-item"
            :style="{ left: sliderLeft }"
          >
            <div id="slider-icon" class="slide-verify-slider-mask-item-icon"></div>
          </div>
        </div>
        <span class="slide-verify-slider-text fs-12">{{ sliderText }}</span>
      </div>
    </div>
  </div>
</template>
<script>
const PI = Math.PI;

function sum(x, y) {
  return x + y;
}

function square(x) {
  return x * x;
}
export default {
  name: "SlideVerify",
  props: {
    // block length
    l: {
      type: Number,
      default: 42
    },
    // block radius
    r: {
      type: Number,
      default: 10
    },
    // canvas width
    w: {
      type: Number,
      default: 310
    },
    // canvas height
    h: {
      type: Number,
      default: 155
    },
    page: {
      type: String,
      default: ""
    },
    sliderText: {
      type: String,
      default: "Slide to verify"
    },
    emailValid: {
      type: Boolean,
      default: false
    },
    passwordValid: {
      type: Boolean,
      default: false
    },
    password2Valid: {
      type: Boolean,
      default: false
    },
    accuracy: {
      type: Number,
      default: 5 
    },
    show: {
      type: Boolean,
      default: true
    },
    imgs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      containerActive: false, // container active class
      containerSuccess: false, // container success class
      containerFail: false, // container fail class
      canvasCtx: null,
      blockCtx: null,
      block: null,
      block_x: undefined, // container random position
      block_y: undefined,
      L: this.l + this.r * 2 + 3, // block real length
      img: undefined,
      originX: undefined,
      originY: undefined,
      isMouseDown: false,
      trail: [],
      sliderLeft: 0, // block right offset
      sliderMaskWidth: 0, // mask width,
      success: false,
      loadBlock: true, 
      timestamp: null,
      sliderDoneText: "",
      canvasImgWidth: 0,
      canvasImgHeight: 0,
      oldCanvasWidth: 0,
    };
  },
  mounted() {
    this.init();

    this.oldCanvasWidth = document.getElementById('captcha-container').offsetWidth;      
    this.setDimension();
    window.addEventListener('resize', this.setDimension);
  },
  methods: {
    async init() {
      this.sliderDoneText = this.$t('label-common-done');
      await this.initDom();
      await this.initImg();
      await this.bindEvents();
    },
    initDom() {
      this.block = this.$refs.block;
      this.canvasCtx = this.$refs.canvas.getContext("2d");
      this.blockCtx = this.block.getContext("2d");

      let $$ = this.Dom7;
      $$("#slider-icon").removeClass('done slide-verify-slider-mask-item-icon').addClass('slide-verify-slider-mask-item-icon');
    },
    initImg() {
      this.showPreloader();
      console.log("loading captcha image")
      const img = this.createImg(() => {
        this.loadBlock = false;
        this.drawBlock();
        this.canvasCtx.drawImage(img, 0, 0, this.canvasImgWidth, this.h);
        this.blockCtx.drawImage(img, 0, 0, this.canvasImgWidth, this.h);
        let { block_x: x, block_y: y, r, L } = this;
        let _y = y - r * 2 - 1;
        let ImageData = this.blockCtx.getImageData(x, _y, L, L);
        this.block.width = L;
        this.blockCtx.putImageData(ImageData, 0, _y);

        console.log("captcha image loaded")
        this.hidePreloader();
      });
      this.img = img;
    },
    drawBlock() {
      this.block_x = this.getRandomNumberByRange(
        this.L + 10,
        this.canvasImgWidth - (this.L + 10)
      );
      this.block_y = this.getRandomNumberByRange(
        10 + this.r * 2,
        this.h - (this.L + 10)
      );
      this.draw(this.canvasCtx, this.block_x, this.block_y, "fill");
      this.draw(this.blockCtx, this.block_x, this.block_y, "clip");
    },
    draw(ctx, x, y, operation) {
      let { l, r } = this;
      ctx.beginPath();
      ctx.moveTo(x, y);
      ctx.arc(x + l / 2, y - r + 2, r, 0.72 * PI, 2.26 * PI);
      ctx.lineTo(x + l, y);
      ctx.arc(x + l + r - 2, y + l / 2, r, 1.21 * PI, 2.78 * PI);
      ctx.lineTo(x + l, y + l);
      ctx.lineTo(x, y + l);
      ctx.arc(x + r - 2, y + l / 2, r + 0.4, 2.76 * PI, 1.24 * PI, true);
      ctx.lineTo(x, y);
      ctx.lineWidth = 2;
      ctx.fillStyle = "rgba(255, 255, 255, 0.7)";
      ctx.strokeStyle = "rgba(255, 255, 255, 0.7)";
      ctx.stroke();
      ctx[operation]();
      ctx.globalCompositeOperation = "destination-over";
    },
    createImg(onload) {
      const img = document.createElement("img");
      img.crossOrigin = "Anonymous";
      img.onload = onload;
      img.onerror = () => {
        img.src = this.getRandomImg();
      };
      img.src = this.getRandomImg();
      return img;
    },
    getRandomImg() {
      const len = this.imgs.length;
      var theImages = new Array();
      
      for (var j = 1; j <= 20; j++){
        theImages.push("img_"+j+".jpg")
      }

      var i = 0
      var p = theImages.length;
      var preBuffer = new Array()
      for (i = 0; i < p; i++){
         preBuffer[i] = new Image()
         preBuffer[i].src = theImages[i]
      }
      var whichImage = Math.round(Math.random()*(p-1));

      return len > 0
        ? this.imgs[this.getRandomNumberByRange(0, len - 1)]
        //: require('../assets/img/captchaslider/'+theImages[whichImage]);
        : require('../../public/images/captchaslider/'+theImages[whichImage]);
    },
    getRandomNumberByRange(start, end) {
      return Math.round(Math.random() * (end - start) + start);
    },
    async refresh() {
      this.showPreloader();
      console.log("show preloader")
      await this.reset();
      this.$emit("refresh");
    },
    sliderDown(event) {
      if (this.success) return;
      this.originX = event.clientX;
      this.originY = event.clientY;
      this.isMouseDown = true;
      this.timestamp = +new Date();
    },
    touchStartEvent(e) {
      if (this.success) return;
      this.originX = e.changedTouches[0].pageX;
      this.originY = e.changedTouches[0].pageY;
      this.isMouseDown = true;
      this.timestamp = +new Date();
    },
    bindEvents() {
      document.addEventListener("mousemove", this.handleMoveEvent);
      document.addEventListener("mouseup", this.handleMoveEndEvent);
    },
    handleMoveEvent: throttle(function(e, type = "mouse") {
      if (!this.isMouseDown) return false;
      const moveX =
        type === "mouse"
          ? e.clientX - this.originX
          : e.changedTouches[0].pageX - this.originX;
      const moveY =
        type === "mouse"
          ? e.clientY - this.originY
          : e.changedTouches[0].pageY - this.originY;
      if (moveX < 0 || moveX + 38 >= this.canvasImgWidth) return false;
      this.sliderLeft = moveX + "px";
      let blockLeft = ((this.canvasImgWidth - 40 - 20) / (this.canvasImgWidth - 40)) * moveX;
      this.block.style.left = blockLeft + "px";

      this.containerActive = true; // add active
      this.sliderMaskWidth = moveX + "px";
      this.trail.push(moveY);
    }),
    handleMoveEndEvent(e, type = "mouse") {
      if (!this.isMouseDown) return false;
      this.isMouseDown = false;
      if (
        (type === "mouse" && e.clientX === this.originX) ||
        (type === "touch" && e.changedTouches[0].pageX === this.originX)
      )
        return false;
      this.containerActive = false; // remove active
      this.timestamp = +new Date() - this.timestamp;

      const { spliced, TuringTest } = this.verify();
      if (spliced) {
        if (this.accuracy === -1) {
          this.containerSuccess = true;
          this.success = true;
          let $$ = this.Dom7;
          $$("#text-slider").removeClass('d-none');
          $$("#slider-icon").removeClass('slide-verify-slider-mask-item-icon').addClass('done');
          $$("#slider-verified").removeClass('d-none');

          this.$emit("success", this.timestamp);
          return;
        }
        if (TuringTest) {
          // succ
          this.containerSuccess = true;
          this.success = true;
          let $$ = this.Dom7;
          $$("#text-slider").removeClass('d-none');
          $$("#slider-icon").removeClass('slide-verify-slider-mask-item-icon').addClass('done');
          $$("#slider-verified").removeClass('d-none');
          this.$emit("success", this.timestamp);
        } else {
          this.containerFail = true;
          this.$emit("again");
        }
      } else {
        this.containerFail = true;
        this.$emit("fail");
        
        setTimeout(() => {
          this.reset();
        }, 1000);
        
      }

      /*
      // CHECK EMAIL & PASSWORD VALIDITY
      var isFormValid = false;
      if(this.page == "login"){
        isFormValid = this.emailValid && this.passwordValid
      }else if(this.page == "register"){
        isFormValid = this.emailValid && this.passwordValid && this.password2Valid
      }

      if(isFormValid){
        
      }else{
        this.$emit("invalid");
        this.reset();
      }
      */
    },
    verify() {
      const arr = this.trail; // drag y move distance
      const average = arr.reduce(sum) / arr.length; // average
      const deviations = arr.map(x => x - average); // deviation array
      const stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length); // standard deviation
      const left = parseInt(this.block.style.left);
      const accuracy =
        this.accuracy <= 1 ? 1 : this.accuracy > 10 ? 10 : this.accuracy;
      return {
        spliced: Math.abs(left - this.block_x) <= accuracy,
        TuringTest: average !== stddev // equal => not person operate
      };
    },
    reset() {
      this.showPreloader();
      let $$ = this.Dom7;
      $$("#text-slider").removeClass('d-none').addClass('d-none');
      $$("#slider-icon").removeClass('done slide-verify-slider-mask-item-icon').addClass('slide-verify-slider-mask-item-icon');
      $$("#slider-verified").removeClass('d-none').addClass('d-none');

      this.success = false;
      this.containerActive = false;
      this.containerSuccess = false;
      this.containerFail = false;
      this.sliderLeft = 0;
      this.block.style.left = 0;
      this.sliderMaskWidth = 0;
      // canvas
      let { canvasImgWidth, h } = this;
      this.canvasCtx.clearRect(0, 0, canvasImgWidth, h);
      this.blockCtx.clearRect(0, 0, canvasImgWidth, h);
      this.block.width = canvasImgWidth;

      // generate img
      this.img.src = this.getRandomImg();
      this.$emit("fulfilled");
      //this.hidePreloader();
    },
    setDimension(){
      this.showPreloader();
      var divWidth = document.getElementById('captcha-container').offsetWidth;
      var divHeight = document.getElementById('captcha-container').offsetHeight;

      this.canvasImgWidth = divWidth - 8;
      this.canvasImgHeight = divHeight - 8;
      
      if(this.oldCanvasWidth != divWidth){
        console.log("captcha container width has changed");
        this.reset();
        this.oldCanvasWidth = divWidth;
      }

      this.hidePreloader();
      
    }
  },
  destroyed() {
    document.removeEventListener("mousemove", this.handleMoveEvent);
    document.removeEventListener("mouseup", this.handleMoveEndEvent);
    window.removeEventListener("resize", this.setDimension);
  }
};

function throttle(
  fn,
  interval = 50,
  options = { leading: true, trailing: true }
) {
  const { leading, trailing, resultCallback } = options;
  let lastTime = 0;
  let timer = null;

  const _throttle = function(...args) {
    return new Promise((resolve) => {
      const nowTime = new Date().getTime();
      if (!lastTime && !leading) lastTime = nowTime;

      const remainTime = interval - (nowTime - lastTime);
      if (remainTime <= 0) {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }

        const result = fn.apply(this, args);
        if (resultCallback) resultCallback(result);
        resolve(result);
        lastTime = nowTime;
        return;
      }

      if (trailing && !timer) {
        timer = setTimeout(() => {
          timer = null;
          lastTime = !leading ? 0 : new Date().getTime();
          const result = fn.apply(this, args);
          if (resultCallback) resultCallback(result);
          resolve(result);
        }, remainTime);
      }
    });
  };

  _throttle.cancel = function() {
    if (timer) clearTimeout(timer);
    timer = null;
    lastTime = 0;
  };

  return _throttle;
}
</script>
<style scoped>
.slide-verify {
  position: relative;
}

.slider-verify-loading {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  z-index: 999;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    opacity: 0.7;
  }
  100% {
    opacity: 9;
  }
}

.slide-verify-block {
  position: absolute;
  left: 0;
  top: 0;
}

.slide-verify-refresh-icon {
  position: absolute;
  right: 0;
  top: 0;
  width: 34px;
  height: 34px;
  cursor: pointer;
  background: url("../assets/img/icon/icon_light.png") 0 -437px;
  background-size: 34px 471px;
}

.slide-verify-slider {
  position: relative;
  text-align: center;
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin-top: 15px;
  background: #f7f9fa;
  color: #45494c;
  border: 1px solid #e4e7eb;
}

.slide-verify-slider-mask {
  position: absolute;
  left: 0;
  top: 0;
  height: 40px;
  border: 0 solid var(--f7-color-green3);
  background: var(--f7-color-green3);
}

.slide-verify-slider-mask-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  background: #fff;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: background 0.2s linear;
}


.slide-verify-slider-mask-item-icon {
  position: absolute;
  top: 15px;
  left: 13px;
  width: 14px;
  height: 12px;
  background: url("../assets/img/icon/icon-captcha-slider.svg") no-repeat;
}

#slider-icon.done:after {
  font-family: 'Framework7 Icons';
  content: 'checkmark_alt';
  font-size: var(--wandr-font-size-level-6);
  color: var(--f7-color-white);
  background-color: var(--f7-color-green3);
  padding: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-top: 10px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container-active .slide-verify-slider-mask-item {
  height: 38px;
  top: -1px;
  border: 1px solid var(--f7-color-green3);
}

.container-active .slide-verify-slider-mask {
  height: 38px;
  border-width: 1px;
}

.container-success .slide-verify-slider-mask-item {
  height: 38px;
  top: -1px;
  border: 1px solid var(--f7-color-gray3);
}

.container-success .slide-verify-slider-mask {
  height: 38px;
  border: 1px solid var(--f7-color-green3);
  background-color: var(--f7-color-green3);
}

.container-success .slide-verify-slider-mask-item-icon {
  background-position: 0 0 !important;
}

.container-fail .slide-verify-slider-mask-item {
  height: 38px;
  top: -1px;
  border: 1px solid var(--f7-color-gray3);
}

.container-fail .slide-verify-slider-mask {
  height: 38px;
  border: 1px solid var(--f7-input-error-text-color);
  background-color: var(--f7-input-error-text-color);
}

.container-fail .slide-verify-slider-mask-item-icon {
  top: 14px;
  background-position: 0 -82px !important;
}

.container-active .slide-verify-slider-text,
.container-success .slide-verify-slider-text,
.container-fail .slide-verify-slider-text {
  display: none;
}

#slider-verified{
  position:absolute;
  display: block;
  text-align: center;
  width: 100%;
  top: 25%;
  z-index: 10;
}

</style>
